export default "__VITE_ASSET__b04c36d2__"